import type { IconName } from '@lego/icons'
import React, { ComponentProps, FC, PropsWithoutRef } from 'react'
import { ReactSVG } from 'react-svg'

import { getIconSrc } from './GetIconSrc'

export interface IconProps
  extends Omit<PropsWithoutRef<ComponentProps<typeof ReactSVG>>, 'src' | 'wrapper'> {
  /**
   * The name of the icon to display
   * These are the names of the icons that are available in the LEGO design system
   * see https://www.assets.lego.com/icons/index.html
   */
  name: IconName
  /**
   * Whether the icon should be solid or not
   * note: this adds a '-solid' postfix to the icon name
   */
  solid?: boolean
}

export const Icon: FC<IconProps> = ({ name, solid = false, ...restProps }) => {
  return <ReactSVG src={getIconSrc(name, solid)} wrapper={'div'} {...restProps} />
}

export type { IconName } from '@lego/icons'
